import React, { useEffect, useRef } from 'react';

import { IVrPaymentVaultLinkResult, OutcomeResult } from '../types';

export interface IHostedPaymentVaultedCardFormProps {
  data: IVrPaymentVaultLinkResult;
  onResult: (outcome: OutcomeResult) => void;
}

export const HostedPaymentVaultedCardForm: React.FC<IHostedPaymentVaultedCardFormProps> = ({
  data,
  onResult,
}) => {
  const vaultedPaymentFormRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (!data) {
      return undefined;
    }

    function listener(event: MessageEvent) {
      const origin = new URL(event.origin);
      if (!origin.hostname.endsWith('.rbictg.com')) {
        return;
      }
      if (event.data.type !== 'payment-outcome') {
        return;
      }
      const body = event.data.body as OutcomeResult;

      onResult(body);
    }

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [data, onResult]);

  useEffect(() => {
    if (data && vaultedPaymentFormRef) {
      vaultedPaymentFormRef.current?.submit();
    }
  }, [data, vaultedPaymentFormRef]);

  return (
    <>
      <form
        action={data.link}
        method="post"
        ref={vaultedPaymentFormRef}
        target="vaulted-card-payment-form"
      >
        <input type="hidden" name="data" value={data.data} />
      </form>
      <iframe
        data-testid="vaulted-payment"
        name="vaulted-card-payment-form"
        title="Vaulted Card Payment Form"
        style={{ border: 'none', width: '100%', height: '600px' }}
      />
    </>
  );
};
